module.exports = __webpack_public_path__ + "media/app/img/youtube_3-e3fa80c169b3af506a85e0946538b603.png";